import { Component, Injector, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { AppComponentBase } from '@shared/common/app-component-base';
import { MomentFormatPipe } from "shared/utils/moment-format.pipe";
import { CalendarModule } from 'primeng/calendar';

@Component({
    selector: 'fullDateCalendar',
    templateUrl: './full-date-calendar.component.html',
    styles: ['::ng-deep.ui-datepicker-buttonbar > div.ui-g div:first-child { display: none; }'],
    animations: [appModuleAnimation()],
    providers: [MomentFormatPipe]
})
export class FullDateCalendarComponent extends AppComponentBase implements OnInit {

    @Input() dateStringInput: string;
    @Output() dateStringInputChange: EventEmitter<any> = new EventEmitter();
    @Input() styleClass?: string;
    @Input() inputStyleClass?: string;

    @Output() ngOnChangesEvent: EventEmitter<any> = new EventEmitter();

    @ViewChild('calendarObject', { static: false }) calendar;
    @Input() showClearButton: boolean = false;
    @Input() required: boolean = false;

    inputDate: Date;
    currentYear: number;

    constructor(
        injector: Injector,
        private _momentFormatPipe: MomentFormatPipe
    ) {
        super(injector);
    }

    ngOnInit() {
        this.currentYear = new Date().getFullYear();

        if (this.dateStringInput != null) {
            this.inputDate = new Date(this.dateStringInput);
        }
    }

    ngOnChanges() {
        if (this.dateStringInput != null) {
            this.inputDate = new Date(this.dateStringInput);
        } else {
            this.inputDate = null;
        }
        this.ngOnChangesEvent.emit();
    }

    getYearRange(): string {
        return this.currentYear + ":" + (this.currentYear + 5);
    }

    emitOutput() {
        this.dateStringInput = this.inputDate == null ? null : this._momentFormatPipe.transform(this.inputDate.toISOString(), "MM/DD/YYYY");
        this.dateStringInputChange.emit(this.dateStringInput);
    }
    
    clearDate() {
        this.inputDate = null;
        this.calendar.overlayVisible = false;
        this.emitOutput();
    }

    isValid(): boolean {
        if (this.required == false || this.inputDate != null)
            return true;
        return false;
    }
}
